import type { Contact } from '@nutralab/api';

import { ContactType } from '@/shared/constants';

type ContactMap = Record<ContactType, string>;

const KNOWN_TYPES = new Set<string>(Object.values(ContactType));

export function getContacts(contacts: Contact[]): ContactMap {
    const map = {} as ContactMap;
    for (const { type, value } of contacts) {
        if (KNOWN_TYPES.has(type)) {
            map[type as ContactType] = value;
        }
    }
    return map;
}
